// @packages
import axios from 'axios';

// @scripts
import { config } from '../config';

// @constants
export const CLEAR_CANDIDATE_PRODUCTS = 'CLEAR_CANDIDATE_PRODUCTS';
export const GET_CANDIDATE_PRODUCTS = 'GET_CANDIDATE_PRODUCTS';
export const GET_SEARCH_INPUTS = 'GET_SEARCH_INPUTS';
export const GET_SCHEDULE_PRODUCTS = 'GET_SCHEDULE_PRODUCTS';
export const REMOVE_ITEMS_FROM_SCHEDULE = 'REMOVE_ITEMS_FROM_SHEDULE';

/**
 * @param {object} request -
 * Dynamic parameters from the different pages of the application.
 * For more information check the search for each page individually.
 */
export const getCandidateProducts = (request) => (dispatch) => axios
    .post(config.services.product.getCandidate, request)
    .then((response) =>
        dispatch({
            type: GET_CANDIDATE_PRODUCTS,
            payload: response
                .map((item) => Object.assign(item, {
                    brand: request.brand,
                    louversInputs: {
                        flow: request.flow,
                        height: request.height,
                        width: request.width,
                        pressure: request.pressure,
                        intakeexhaust: request.intakeexhaust,
                        certification: request.certification,
                        louverDepth: request.louverDepth,
                        material: request.material,
                        bladeType: request.bladeType,
                        wpFactor: request.wpFactor
                    }
                }))
        })

    )
    .catch(e => {
        console.log(e);
    });


export const clearCandidateProducts = () => ({
    type: CLEAR_CANDIDATE_PRODUCTS
});

export const getSearchInputs = (request) => (dispatch) => axios
    .get(config.services.product.getSearchInputs, request)
    .then((response) =>
        dispatch({
            type: GET_SEARCH_INPUTS,
            payload: response
        })
    )
    //.catch((error) => Promise.reject(error));
    .catch(e => {
        console.log(e);
    });

export const getScheduleProducts = () => (dispatch) => axios
    .get(config.services.product.getSchedule)
    .then((response) => dispatch({
        type: GET_SCHEDULE_PRODUCTS,
        payload: response
    }))
    .catch((error) => Promise.reject(error));

/**
 * @param {object[]} items
 */
export const removeItemsFromSchedule = (items) => ({
    type: REMOVE_ITEMS_FROM_SCHEDULE,
    payload: items
});
